import regex from './regex-rules.js';

/**
 * Metode custom de validare
 */
export const customValidate = {
	/**
	 * Validare litere inclusiv cu diacritice
	 * @param {string} value Valoare de validat
	 * @param {HTMLElement} element Inputul pe care se face validarea
	 * @returns {boolean}
	 */
	alpha: function (value, element) {
		return this.optional(element) || regex.lettersSpacesHyphens.test(value);
	},

	/**
	 * Validare litere (inclusiv diacritice) si cifre
	 * @param {string} value Valoare de validat
	 * @param {HTMLElement} element Inputul pe care se face validarea
	 * @returns {boolean}
	 */
	alphaNumeric: function (value, element) {
		return this.optional(element) || regex.lettersSpacesHyphensDigits.test(value);
	},

	/**
	 * Validare numar de telefon sa inceapa cu 0 si sa aiba 10 cifre
	 * @param {string} value Valoare de validat
	 * @param {HTMLElement} element Inputul pe care se face validarea
	 * @returns {boolean}
	 */
	phone: function (value, element) {
		return this.optional(element) || regex.phone.test(value);
	},

	/**
	 * Validare nume companie
	 * @param {string} value Valoare de validat
	 * @param {HTMLElement} element Inputul pe care se face validarea
	 * @returns {boolean}
	 */
	companyName: function (value, element) {
		return this.optional(element) || regex.companyName.test(value);
	},

	/**
	 * Validare CUI companie (inclusiv RO)
	 * @param {string} value Valoare de validat
	 * @param {HTMLElement} element Inputul pe care se face validarea
	 * @returns {boolean}
	 */
	companyCode: function (value, element) {
		return this.optional(element) || regex.companyCode.test(value);
	},

	/**
	 * Validare CUI companie (doar numeric)
	 * @param {string} value Valoare de validat
	 * @param {HTMLElement} element Inputul pe care se face validarea
	 * @returns {boolean}
	 */
	companyCodeNumeric: function (value, element) {
		return this.optional(element) || regex.companyCodeNumeric.test(value);
	},

	/**
	 * Validare coordonate GPS
	 * @param {string} value Valoare de validat
	 * @param {HTMLElement} element Inputul pe care se face validarea
	 * @returns {boolean}
	 */
	gpsCoords: function (value, element) {
		return this.optional(element) || regex.gpsCoords.test(value);
	},

	/**
	 * Validare cod client sa aiba strict 12 cifre
	 * @param {string} value Valoare de validat
	 * @param {HTMLElement} element Inputul pe care se face validarea
	 * @returns {boolean}
	 */
	codClient: function (value, element) {
		return this.optional(element) || regex.codClient.test(value);
	},
};

/**
 * Mesaje custom de validare
 */
export const customMessages = {
	/**
	 * Intoarce mesaj de eroare la required
	 * @param {string?} field Numele campului
	 * @returns {string}
	 */
	required: (field) => {
		return field ? `"${field}" este obligatoriu.` : 'Câmpul este obligatoriu.';
	},

	/**
	 * Intoarce mesaj de eroare la validateCompanyName
	 * @param {string?} field Numele campului
	 * @returns {string}
	 */
	companyName: (field) => {
		const msg = 'Sunt permise doar caractere alfanumerice și din setul [-, &, .]';
		return field ? `${msg} la "${field}".` : `${msg}.`;
	},

	/**
	 * Intoarce mesaj de eroare la validateCompanyCode
	 * @param {string?} field Numele campului
	 * @returns {string}
	 */
	companyCode: (field) => {
		const msg = 'Trebuie să introduci un CUI valid';
		return field ? `${msg} la "${field}".` : `${msg}.`;
	},

	/**
	 * Intoarce mesaj de eroare la minlength
	 * @param {string?} field Numele campului
	 * @param {number} length Numarul minim de caractere. Default 3
	 * @param {string} type Caractere sau cifre. Default 'caractere'
	 * @returns {string}
	 */
	minlength: (field, length = 3, type = 'caractere') => {
		const msg = `Trebuie cel puțin ${length} ${type}`;
		return field ? `${msg} la "${field}".` : `${msg}.`;
	},

	/**
	 * Intoarce mesaj de eroare la maxlength
	 * @param {string?} field Numele campului
	 * @param {number} length Numarul maxim de caractere. Default 50
	 * @param {string} type Caractere sau cifre. Default 'caractere'
	 * @returns {string}
	 */
	maxlength: (field, length = 50, type = 'caractere') => {
		const msg = `Trebuie cel mult ${length} ${type}`;
		return field ? `${msg} la "${field}".` : `${msg}.`;
	},

	/**
	 * Intoarce mesaj de eroare la email
	 * @param {string?} field Numele campului
	 * @returns {string}
	 */
	email: (field) => {
		const msg = 'Trebuie o adresă validă de e-mail';
		return field ? `${msg} la "${field}".` : `${msg}.`;
	},

	/**
	 * Intoarce mesaj de eroare la validateAlpha
	 * @param {string?} field Numele campului
	 * @returns {string}
	 */
	alpha: (field) => {
		const msg = 'Sunt permise doar litere și spații';
		return field ? `${msg} la "${field}".` : `${msg}.`;
	},

	/**
	 * Intoarce mesaj de eroare la validare alphaNumeric
	 * @param {string?} field Numele campului
	 * @returns {string}
	 */
	alphaNumeric: (field) => {
		const msg = 'Sunt permise doar litere, spații și cifre';
		return field ? `${msg} la "${field}".` : `${msg}.`;
	},

	/**
	 * Intoarce mesaj de eroare la validatePhone
	 * @param {string?} field Numele campului
	 * @returns {string}
	 */
	phone: (field) => {
		const msg = 'Trebuie 10 cifre și prima să fie 0';
		return field ? `${msg} la "${field}".` : `${msg}.`;
	},

	/**
	 * Intoarce mesaj de eroare la digits
	 * @param {string?} field Numele campului
	 * @returns {string}
	 */
	digits: (field) => {
		const msg = 'Sunt permise doar cifre';
		return field ? `${msg} la "${field}".` : `${msg}.`;
	},

	/**
	 * Intoarce mesaj de eroare la codClient (strict 12 cifre)
	 * @param {string?} field Numele campului
	 * @returns {string}
	 */
	codClient: (field) => {
		const msg = 'Trebuie să introduci un cod client format din 12 cifre';
		return field ? `${msg} la "${field}".` : `${msg}.`;
	},

	/**
	 * Intoarce mesaj de eroare la number
	 * @param {string?} field Numele campului
	 * @param {number} min Valoarea minima
	 * @param {number} max Valoarea maxima
	 * @returns {string}
	 */
	number: (field, min, max) => {
		const msg = `Trebuie un număr între ${min} și ${max}`;
		return field ? `${msg} la "${field}".` : `${msg}.`;
	},

	/**
	 * Intoarce mesaj de eroare la radio group
	 * @param {string?} field Numele campului
	 * @returns {string}
	 */
	radio: (field) => {
		const msg = 'Trebuie să alegi o opțiune';
		return field ? `${msg} la "${field}".` : `${msg}.`;
	},

	/**
	 * Intoarce mesaj de eroare daca nu s-a bifat checkboxul de acord
	 * @returns {string}
	 */
	gdpr: () => {
		return 'Trebuie să iei la cunoștință nota generală de informare cu privire la protecția datelor.';
	},
};

/**
 * Restrictioneaza caracterele care pot fi introduse intr-un form field
 * @param {string} field Selector camp, poate fi HTML id sau clasa CSS
 * @param {string} regex Reguli de restrictionare
 */
export const restrictInput = (field, regex) => {
	document.querySelector(field)?.addEventListener('keypress', (e) => {
		if (e.key.match(regex) === null) {
			e.preventDefault();
		}
	});
};
